import { useState } from 'react';
import { AdjustmentGridViewProps } from 'components';
import { AdjustmentType } from 'enums';
import { useAdjustmentCategory } from 'hooks';
import { AdjustmentCategoryGridProps, AdjustmentDetail } from 'types';

type SelectedCategoryData = {
    gridProps: AdjustmentGridViewProps,
    selectCategory: (category?: AdjustmentType) => void,
    selectedCategory: AdjustmentType
};

export default function useSelectedCategory(adjustments: AdjustmentDetail[],
    adjustmentTypeMap: Map<AdjustmentType, AdjustmentCategoryGridProps>, defaultCategory: AdjustmentType, onSelect?: () => void): SelectedCategoryData {

    const [selectedCategory, setSelectedCategory] = useState<AdjustmentType>(defaultCategory)
    const gridProps = useAdjustmentCategory(adjustments, adjustmentTypeMap, selectedCategory);

    const selectCategory = (category?: AdjustmentType) => {
        setSelectedCategory(category ?? defaultCategory);
        onSelect && onSelect();
    }

    return {
        gridProps,
        selectCategory,
        selectedCategory 
    };
}